import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from '../../../../constants/moment';
import {
    toggleModal,
    getAll,
    setValue,
    createNew,
    update,
    deleteEntity,
    tableActions,
} from "../../../../../redux/actions/referencesActions";
import {
    Button,
    Modal
} from "react-bootstrap";
import {
    TextField,
    FormHelperText,
    Chip,
    Avatar,
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableRow,
} from "@material-ui/core";
import FileUpload from "../../../../helpers/fileupload/FileUpload";
import DataTable from "../../../../helpers/datatable/DataTable";

import Loading from "../../../../helpers/loading/Loading";
import {
    sortCaret,
    headerSortingClasses,
} from "../../../../../_metronic/_helpers";
import actionsFormatter from "../../../../helpers/datatable/formatters/actionsFormatter";
import { textFilter } from 'react-bootstrap-table2-filter';
import {
    globalURL
} from "../../../../constants/constants";

function ReferencesPage(props) {
    useEffect(() => {
        props.getAll(props.auth.user.token);
        return () => {
            // will unMount 
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const columns = [
        {
            dataField: "image.name",
            text: "LOGO",
            sort: false,
            filter: null,
            formatter: (item) => {
                return item ? <img src={globalURL + "/images/" + item} style={{ height: 30 }} /> : null
            }
        },
        {
            dataField: "name",
            text: "Referans Şirket Adı",
            sort: true,
            filter: textFilter({
                placeholder: "Ara",
                style: {
                    display: props.references.data.length > 0 ? "block" : "none"
                }
            }),
            sortCaret: sortCaret,
            headerSortingClasses
        },
        {
            dataField: "action",
            text: "",

            classes: "text-right pr-0",
            headerClasses: "text-right pr-3",
            style: {
                minWidth: "100px",
            },
            formatter: (cell, row) => {
                return actionsFormatter(cell, row, props.tableActions, props.auth.user.token)
            }

        }
    ];

    return <>
        <Loading show={props.references.isFetchingDetail} />
        <Modal backdrop="static" size="lg" show={props.references.showModal} onHide={() => props.toggleModal(false, "")}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i style={{ marginRight: 5 }} className={props.references.process === "create" ? "fa fa-plus" : props.references.process === "update" ? "fa fa-edit" : "fa fa-trash-alt"}></i>
                    {props.references.process === "create" ? "Yeni Referans" : props.references.process === "update" ? "Referans Düzenle" : "Referans Sil"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.references.process === "create" || props.references.process === "update" ?
                    <div>
                        <TextField
                            label="Adı"
                            style={{ margin: 8 }}
                            placeholder="Adı"
                            autoComplete="off"
                            error={props.references.name_error}
                            value={props.references.name}
                            onChange={(event) => props.setValue("name", event.target.value)}
                            helperText={props.references.name_helpertext}
                            fullWidth
                            margin="normal"
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            FormHelperTextProps={{
                                style: {
                                    marginLeft: 0
                                }
                            }}
                        />

                        <div style={{ marginTop: 8, marginLeft: 7, width: "100%" }}>
                            <FileUpload
                                {...props}
                                multiple={false}
                                dropzoneText={"Resim Seçiniz 155 x 30"}
                                stateKey={"image"}
                                uploadedImages={props.references.image}
                            />
                        </div>
                        {
                            props.references.process === "update" && props.references.detail !== null ?
                                <>
                                    <div className="separator separator-dashed my-7"></div>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>REFERANS DETAYLARI</TableCell>
                                                <TableCell></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {
                                                props.references.detail.createdBy !== null ?
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            <FormHelperText>Oluşturan Kullanıcı / Zamanı</FormHelperText><br />
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            <Chip
                                                                style={{ marginLeft: -5 }}
                                                                avatar={<Avatar>{String(props.references.detail.createdBy.name[0]).toUpperCase() + String(props.references.detail.createdBy.surname[0]).toUpperCase()}</Avatar>}
                                                                label={props.references.detail.createdBy.username}
                                                            /><br />
                                                            <small>{moment(props.references.detail.createdAt).format('DD.MM.YYYY HH:mm:ss')}</small><br />
                                                            <small>{moment(props.references.detail.createdAt).fromNow()}</small>
                                                        </TableCell>
                                                    </TableRow> : null
                                            }

                                            {
                                                props.references.detail.updatedBy !== undefined && props.references.detail.updatedBy !== null ?
                                                    <TableRow>
                                                        <TableCell component="th" scope="row">
                                                            <FormHelperText>Son Güncelleyen Kullanıcı / Zamanı</FormHelperText>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            <Chip
                                                                style={{ marginLeft: -5 }}
                                                                avatar={<Avatar>{String(props.references.detail.updatedBy.name[0]).toUpperCase() + String(props.references.detail.updatedBy.surname[0]).toUpperCase()}</Avatar>}
                                                                label={props.references.detail.updatedBy.username}
                                                            /><br />
                                                            <small>{moment(props.references.detail.updatedAt).format('DD.MM.YYYY HH:mm:ss')}</small><br />
                                                            <small>{moment(props.references.detail.updatedAt).fromNow()}</small>
                                                        </TableCell>
                                                    </TableRow> : null
                                            }
                                        </TableBody>
                                    </Table></> : null
                        }
                    </div> :
                    props.table.row !== null && props.table.row.name ?
                        <>
                            <b>{'"'}{props.table.row.name}{'" '}</b> isimli referansı silmek üzeresiniz. İşlemi onaylıyor musunuz?
                        </> : null
                }
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={props.references.isFetchingActions} variant="secondary" onClick={() => props.toggleModal(false, props.references.process)}>
                    İptal
                </Button>
                <Button style={{ minWidth: 50, minHeight: 39, display: "flex", flexDirection: "row", alignItems: "center" }} disabled={props.references.isFetchingActions} onClick={() => {
                    if (props.references.process === "create") {
                        props.createNew(props.auth.user.token,
                            [
                                {
                                    key: "name",
                                    value: props.references.name,
                                    required: true
                                },
                                {
                                    key: "image",
                                    value: props.references.image,
                                    required: false
                                }
                            ])
                    } else if (props.references.process === "update") {
                        props.update(props.auth.user.token, props.table.row.id,
                            [
                                {
                                    key: "name",
                                    value: props.references.name,
                                    required: true
                                },
                                {
                                    key: "image",
                                    value: props.references.image,
                                    required: false
                                }

                            ], props.table.index);
                    } else {
                        props.deleteEntity(props.auth.user.token, props.table.row, props.table.index);
                    }
                }} variant="primary">
                    {
                        props.references.isFetchingActions ?
                            <span className="ml-3 spinner spinner-white"></span> :
                            props.references.process === "delete" ? "Sil" : "Kaydet"
                    }
                </Button>
            </Modal.Footer>
        </Modal>
        <DataTable
            handleModal={props.toggleModal}
            title="Tüm Referanslar"
            buttonTitle="Yeni Referans"
            cardIcon="fa fa-fill-drip"
            buttonIcon="fa fa-plus"
            searchPlaceholder="Ara"
            data={props.references.data}
            columns={columns}
        />
    </>
}

const mapStateToProps = function (state) {
    return {
        auth: state.auth,
        references: state.references,
        table: state.table
    }
}

export default connect(mapStateToProps,
    {
        toggleModal,
        getAll,
        setValue,
        createNew,
        update,
        deleteEntity,
        tableActions,

    })(ReferencesPage);
